<template>
	<div class="full listorder_container flex">
		<vxe-table border ref="xTable1" height="400" class="sortable-row" :row-config="{useKey: true}"
			:scroll-y="{enabled: true}" :data="tableData">
			<vxe-column width="60" title="拖动">
				<template #default>
					<span class="drag-btn">
						<i class="vxe-icon-edit"></i>
					</span>
				</template>
			</vxe-column>
			<vxe-column title="序号" type="seq"></vxe-column>
			<vxe-column field="field" title="字段"></vxe-column>
			<vxe-column title="名称">
				<template #default="{ row }">
					<template>
						<span>{{ row.title.split('|')[0] }}</span>
					</template>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
</template>
<style scoped>
	.listorder_container {
		overflow: hidden;
		flex-direction: column;
		box-sizing: border-box;
		padding: 20px;
	}
</style>

<script>
	import Sortable from 'sortablejs'
	export default {
		props: {
			node: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				showHelpTip1: false,
				tableData: [],
				type: 'main'

			}
		},
		created() {
			this.init()
		},
		beforeDestroy() {
			if (this.sortable1) {
				this.sortable1.destroy()
			}
		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			init() {
				//console.log(this.node.data)
				this.type = this.node.data.type
				let tableData = []
				if (this.node.data.customColumns && this.node.data.customColumns.enable) {
					this.node.data.customColumns.json.forEach((item) => {
						if (item.props.show) {
							tableData.push({
								field: item.field,
								title: item.title,
								listParam: item.props
							})
						}
					})
				} else {
					this.node.data.fields.forEach((item, index) => {
						if (this.type == 'main') {
							if (item.listParam) {
								let listParam = JSON.parse(item.listParam)
								if (listParam.show) {
									tableData.push({
										field: item.field,
										title: item.title,
										listParam: listParam
									})
								}
							}
						} else {
							tableData.push({
								field: item.field,
								title: item.title,
								order: item.order ? item.order : index
							})
						}
					})
				}
				tableData.sort((a, b) => {
					if (this.type == 'main') {
						return a.listParam.order - b.listParam.order
					} else {
						return a.order - b.order
					}

				})
				this.tableData = tableData
				this.rowDrop()
			},
			rowDrop() {
				this.$nextTick(() => {
					const xTable = this.$refs.xTable1
					this.sortable1 = Sortable.create(xTable.$el.querySelector(
						'.body--wrapper>.vxe-table--body tbody'), {
						handle: '.drag-btn',
						onEnd: ({
							newIndex,
							oldIndex
						}) => {
							const currRow = this.tableData.splice(oldIndex, 1)[0]
							this.tableData.splice(newIndex, 0, currRow)
						}
					})
				})
			},
			submit() {
				this.tableData.forEach((item, index) => {
					if (this.node.data.customColumns && this.node.data.customColumns.enable) {
						this.node.data.customColumns.json.forEach((_item) => {
							if (_item.field == item.field) {
								_item.props.order = index + 1
							}
						})
					} else {
						if (this.type == 'main') {
							this.node.data.fields.forEach((_item) => {
								if (_item.field == item.field) {
									let listParam = JSON.parse(_item.listParam)
									listParam.order = index + 1
									_item.listParam = JSON.stringify(listParam)
								}
							})
						} else {
							this.node.data.fields.forEach((_item) => {
								if (_item.field == item.field) {
									_item.order = index + 1
								}
							})
						}
					}
				})
				if (this.node.data.customColumns && this.node.data.customColumns.enable) {
					this.node.data.customColumns.json.sort((a, b) => a.props.order - b.props.order)
				}
			}
		},
		components: {

		}
	}
</script>
